export const NOTIFICATIONS_KEYS = {
	listUnreadNotifications: ["unreadNotifications"],
	listReadNotifications: ["readNotifications"],
} as const;
